import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './__mocks__';
import type { Payment, PaymentChartFilters } from './types/types';

export const paymentsStatusByTypeOfAccrualsApi = createApi({
  reducerPath: 'paymentsStatusByTypeOfAccrualsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/payments-status-by-type-of-accruals`,
  }),
  tagTypes: ['Payments'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getPaymentsStatusByTypeOfAccruals: builder.query<
      Payment[],
      PaymentChartFilters
    >({
      query: params => ({
        url: ``,
        params,
      }),
      providesTags: ['Payments'],
    }),
  }),
});

export const { useGetPaymentsStatusByTypeOfAccrualsQuery } =
  paymentsStatusByTypeOfAccrualsApi;
